export const STRATEGY_DESCRIPTION_SOFT_LIMIT = 3000;
export const STRATEGY_NAME_SOFT_LIMIT = 120;
export const REPORT_TITLE_MAX = 255;
/** Persisted generate-report candle TF preference (bump when product default changes). */
export const REPORT_CANDLE_TIMEFRAME_STORAGE_KEY = "reports_candle_timeframe_v2";
/** Default OHLC candle timeframe for new reports (aligned with Trade Review + BE warm cache). */
export const DEFAULT_REPORT_CANDLE_TIMEFRAME = "1h" as const;

export const GENERATE_REPORT_STEPS = [
  {
    key: "trade_scope",
    label: "Trade scope",
    description: "Choose account, trade side (long/short/both), and date range for this report.",
  },
  {
    key: "report_details",
    label: "Report details",
    description: "Name the report and pick the analysis template.",
  },
  {
    key: "strategy",
    label: "Strategy",
    description: "Attach a saved strategy or describe a new one for this run.",
  },
  {
    key: "generate",
    label: "Generate",
    description: "Review your choices, then generate the report.",
  },
] as const;

export type GenerateReportStepKey = (typeof GENERATE_REPORT_STEPS)[number]["key"];

export type GenerateReportStepMeta = {
  key: GenerateReportStepKey;
  label: string;
  description: string;
};

/** Workspace: skip strategy when the report is already created under a strategy node. */
export function resolveGenerateReportSteps(options?: {
  omitStrategyStep?: boolean;
  strategyStepDescription?: string;
}): GenerateReportStepMeta[] {
  const omitStrategy = Boolean(options?.omitStrategyStep);
  return GENERATE_REPORT_STEPS.filter((step) => !(omitStrategy && step.key === "strategy")).map(
    (step) => {
      if (step.key === "strategy" && options?.strategyStepDescription) {
        return { ...step, description: options.strategyStepDescription };
      }
      return { ...step };
    }
  );
}
